import { createContext, useContext } from 'react'
import { usePermission } from '@/hooks/usePermission'
import { designMode } from './api'

/** Grants access only to the isolated synthetic route, without changing live auth. */
export const CostingFixtureContext = createContext(false)

export function useCostingPermission(capability: 'costing.view' | 'costing.manage') {
  const allowed = usePermission(capability)
  const fixture = useContext(CostingFixtureContext)
  return (fixture && designMode()) || allowed
}
